import { render, staticRenderFns } from "./SSelectProvince.vue?vue&type=template&id=ee7112ac"
import script from "./SSelectProvince.vue?vue&type=script&lang=js"
export * from "./SSelectProvince.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports